<div class="file_upload">
  @if (!multiFileUpload && files.length > 0) {
    <div class="uploaded_files">
      <div class="content">
        <div class="file_type_icon">
          <img src="assets/icons/file_icon.svg">
          <div class="file_type_wrap" [ngStyle]="{'background': getFileTypeColor(files[0].file)}">
            {{ getFileType(files[0].file) }}
          </div>
        </div>
      </div>
      
      <div class="filename_and_size">
        @if (multiFileUpload) {
          <div class="file_name">{{ files?.length }} Files</div>
        } @else {
          <div class="file_name">{{ files?.[0].file.name }}</div>
        <div class="file_size">{{ files?.[0].file.size }}</div>
        }
      </div>

      <div class="delete_icon" (click)="removeFileAdded()" *ngIf="!disabled">
        <img src="assets/icons/delete_icon.svg" alt="delete icon">
      </div>
    </div>
  } @else {
    <div
      class="upload-container"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [class.dragging]="isDragging"
      [ngClass]="{
        'file-required-error':error?.hasError
      }"
    >
      <div class="upload-content">
        <div class="cloud-icon">
          @if (multiFileUpload) {
            <img src="assets/icons/upload_folders_icon.svg" alt="upload_icon">
          } @else {
            <img src="assets/icons/upload_folder_icon.svg" alt="upload_icon">
          }
        </div>
        <input
          #fileInput
          type="file"
          [disabled]="disabled"
          (change)="onFileSelected($event)"
          [multiple]="multiFileUpload"
          class="hidden-input"
        />
        <div class="text_and_upload_btn">
          <div class="upload-text">{{ title }}</div>
          <div class="upload-action">
            <button class="upload-button" [disable]="disabled" (click)="fileInput.click()">
              <img src="assets/icons/upload_icon.svg" /> Upload @if (multiFileUpload) { Files } @else { File }
            </button>
            <div *ngIf="multiFileUpload && files.length > 0" class="attachments">
              <app-svg-icon class="attachment-icon" [path]="'/assets/icons/attachment_icon.svg'"></app-svg-icon>
              <span>{{files.length}}</span>
            </div>
          </div>
          <div class="upload-text error">{{error?.errorMsg}}</div>
        </div>


      </div>
    </div>
      <div class="file_chips" *ngIf="files.length > 0">
        <div class="file_chip" *ngFor="let file of files; let i = index">

          <div class="icon">
            <img class="file_type_icon" src='assets/icons/file_icon.svg'/>
            <div class="file_type_wrap" [ngStyle]="{'background': getFileTypeColor(files[i].file)}">
              {{ getFileType(files[i].file) }}
            </div>
          </div>

          <div class="filename_and_size">
            <div class="file_name">{{ files[i].name }}</div>
          </div>

          <div class="icon" (click)="removeFileAddedForMulti(i)" *ngIf="!disabled">
            <img class="delete_icon" src="assets/icons/delete_icon.svg"/>
          </div>

        </div>
      </div>
  }
</div>


